import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {EmployeeSearchModel} from "../employee-search.model";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {EmployeeSearchPageComponent} from "../employee-search-page/employee-search-page.component";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-employee-single-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/single-select-search-control.component.html",
    providers: [
        provideSearchModel(EmployeeSearchModel),
        registerSearchControl(EmployeeSingleSelectSearchControlComponent)
    ]
})

export class EmployeeSingleSelectSearchControlComponent extends AbstractSelectSearchControlComponent<EmployeeSearchModel> {
    constructor(model: EmployeeSearchModel, injector: Injector) {
        super(model, injector, "userName", "userName");
        this.extendedSearchComponent = EmployeeSearchPageComponent;
    }
}
